import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getRole = ({
  churchId,
  isDenomination = false,
  roleId,
  denominationId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/roles/${roleId}`
  );
};

export const useRole = ({
  churchId,
  isDenomination = false,
  denominationId,
  roleId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["role", roleId, isDenomination ? denominationId : churchId],
    queryFn: () => getRole({ churchId, isDenomination, roleId, denominationId })
  });
};
